import styled from "styled-components"

export const StyledSearchInput = styled.div`
  --icon-width: 24px;
  --icon-margin-right: 4px;
  min-height: 33px;
  display: flex;
  position: relative;
  width: 100%;
`
export const StyledIconBox = styled.label`
  position: absolute;
  text-align: left;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
`

export const StyledInput = styled.input`
  font-size: 13px;
  padding: 8px 7px;
  padding-left: calc(
    var(--icon-width) + var(--icon-margin-right) + var(--icon-margin-right)
  );
  border-radius: 20px;
  border: 0.5px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32));

  color: var(--color-dark);

  width: 100%;
  height: 100%;
  font-size: 14px;
  line-height: 160%;
  min-height: 33px;

  &:focus,
  &:active,
  &:focus-visible {
    outline: none;
    background: var(--Schemes-Surface-Container, #ebedf0);
    border-color: var(--Schemes-Surface-Container, #ebedf0);
  }

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #69757d;
    font-family: proxima-nova;
  }

  &::-moz-placeholder {
    /* Firefox 19+ */
    color: #69757d;
    font-family: proxima-nova;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }

  @supports (-webkit-touch-callout: none) {
    border: 0.8px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32));
  }
`

export const DetailsTrailing = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: var(--color-navy);
  pointer-events: none;
`

export const CloseIconBox = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
`
